module.exports = __webpack_public_path__ + "media/shared/images/apple-touch-icon-iphone-0bb3ff3506a9c1c85a35c405568d96e9.png";